module.exports = __webpack_public_path__ + "img/instagram.0b6b3c8d.png";